module.exports = __webpack_public_path__ + "img/yuanchuandabiao.8cb253c6.svg";